/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { AnalisiDto, GetAnalisiParams } from ".././models";

export const getAnalisi = (
  portale: 1 | 2 | 3,
  params?: GetAnalisiParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<AnalisiDto[]>> => {
  return axios.get(`/api/portali/${portale}/analisi`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetAnalisiQueryKey = (
  portale: 1 | 2 | 3,
  params?: GetAnalisiParams
) => [`/api/portali/${portale}/analisi`, ...(params ? [params] : [])] as const;

export const getGetAnalisiQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalisi>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetAnalisiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalisi>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<Awaited<ReturnType<typeof getAnalisi>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalisiQueryKey(portale, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalisi>>> = ({
    signal,
  }) => getAnalisi(portale, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!portale, ...queryOptions };
};

export type GetAnalisiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalisi>>
>;
export type GetAnalisiQueryError = AxiosError<unknown>;

export const useGetAnalisi = <
  TData = Awaited<ReturnType<typeof getAnalisi>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetAnalisiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalisi>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnalisiQueryOptions(portale, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetAnalisi = () =>
  //@ts-ignore
  useGetAnalisi(...([] as any[]));
